import React from 'react'
import cx from 'classnames'

import { Box } from 'components/layout/Box/Box'
import { IconButton } from 'components/shared/IconButton/IconButton'

import { ArrowLeftIcon } from 'components/shared/Icon/model'

import styles from './PaneHeader.module.scss'

type PaneHeaderProps = {
  children?: React.ReactNode
  className?: string
  contentClassName?: string
  direction?: string
  subtitle?: React.ReactNode
  title?: React.ReactNode
  onBack?: () => void
}

export const PaneHeader = ({
  children,
  className,
  contentClassName,
  direction = 'row',
  subtitle,
  title,
  onBack,
}: PaneHeaderProps) => (
  <Box
    align="center"
    className={cx(styles.header, className)}
    justify={title ? 'flex-start' : 'flex-end'}
  >
    {title != null ? (
      <Box
        align="flex-start"
        className={cx(styles.content, contentClassName)}
        {...{ direction }}
      >
        {onBack ? (
          <IconButton
            className={styles.back}
            icon={ArrowLeftIcon}
            size="medium"
            variant="text"
            onClick={onBack}
          />
        ) : null}
        <h1 className={styles.title}>{title}</h1>
        {subtitle != null ? (
          <h2 className={styles.subtitle}>{subtitle}</h2>
        ) : null}
      </Box>
    ) : null}
    {children}
  </Box>
)
